import { CommonOption } from "api/modules/common.option";
import { formatDate } from "common/service/CommonService";
import { FormFieldConfig } from "Components/Common/CommonForm";
import { validations } from "validations/FormValidations";

 export  const dispensingFields = (studyOptions:CommonOption[], ipCategoryOptions: CommonOption[], subjectOptions:CommonOption[],selectedStudyId:boolean, isIpCategoryLoading: boolean): FormFieldConfig[] => [
    {
      name: "studyid",
      label: "Study Code",
      type: "select",
      options: studyOptions,
      placeholder: "Select Study Code",
      required: true,
      disabled: true,
      rules: validations.dispensingLabel.studyid,
    },
    {
      name: "ipcategory",
      label: "IP Category",
      type: "select",
      options: ipCategoryOptions,
      placeholder: isIpCategoryLoading ? "Loading Categories..." : "Select IP Category",
      disabled: !selectedStudyId || isIpCategoryLoading,
      required: true,
      rules: { required: "IP Category is required" },
    },
    {
      name: "subjectno",
      label: "Subject No",
      type: "select",
      options: subjectOptions,
      placeholder: "Select Subject No",
      disabled: !selectedStudyId,
      required: true,
      rules: validations.dispensingLabel.subjectno,
    },
  ];

  export const dispensingColumns = (selectedAssignmentIds: string[], toggleSelection: (data: any, checked: boolean) => void) => [
    {
      key: "select",
      label: "Action",
      sticky: true,
      width: "50px",
      textCenter: true,
      render: (_: any, data: any) => (
        <div className="d-flex align-items-center justify-content-center">
          <input
            type="checkbox"
            className="form-check-input mt-0 cursor-pointer"
            checked={selectedAssignmentIds.includes(
              data.dispensingsubjectid || data.volunteerassignmentid,
            )}
            onChange={(e) => toggleSelection(data, e.target.checked)}
          />
        </div>
      ),
    },
    {
      key: "subjectno",
      label: "Subject No",
      sticky: true,
      width: "110px",
      render: (val: any) =>
        Number(val) >= 1 && Number(val) <= 9
          ? String(val).padStart(2, "0")
          : val,
    },
    {
      key: "ip",
      label: "IP & Batch / Lot Number",
      render: (_: any, row: any) => `${row.ip} ( ${row.batchno} )`,
    },
    {
      key: "quantity",
      label: "Quantity",
      render: (_: any, row: any) => `${row.quantity}`,
    },
    {
      key: "dosage_strength",
      label: "Dosage Form & Strength",
      render: (_: any, row: any) => `${row.dosageform} - ${row.strength}`,
    },
    {
      key: "expdate",
      label: "Expiration Date",
      render: (val: any) => formatDate(val),
    },
  ];